import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../../base-page.component';
import { Client } from '../../../shared/models/customer.model';
import { MachineModuleService } from '../../../shared/services/machineModule.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  templateUrl: './customers-list-page.component.html',
  standalone: false
})
export class CustomersListPageComponent extends BasePageComponent implements OnInit {
  public customers: Client[] = [];
  public pageNumber = 1;
  public pageSize = 50;
  public hasMore = true;
  search = new FormControl();

  constructor(private route: ActivatedRoute, private router: Router, private customersService: MachineModuleService, location: Location) {
    super(location);
  }

  ngOnInit() {
    this.loadCustomers();
    this.search.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value) => this.onSearch(value));
  }

  loadCustomers(): void {
    if (this.loading || !this.hasMore) {
      return;
    }

    this.loading = true;
    this.customersService.getCustomers(this.pageNumber, this.pageSize, this.query).subscribe(
      (customers) => {
        this.hasMore = customers.length === this.pageSize;
        this.loading = false;
        this.customers.push(...customers);
      },
      () => (this.loading = false)
    );
  }

  loadMore(): void {
    if (!this.loading && this.hasMore) {
      this.pageNumber++;
      this.loadCustomers();
    }
  }

  onSearch(searchTerm: string): void {
    this.query = searchTerm;
    this.pageNumber = 1;
    this.customers = [];
    this.hasMore = true;
    this.loadCustomers();
  }

  openCustomer(customer: Client): void {
    this.router.navigate([this.appRoute, 'customers', customer.clientNumber]);
  }

  createCustomer(): void {
    this.router.navigate([`${this.appRoute}/customers/create`]);
  }

  goToBack() {
    this.router.navigate([this.appRoute]);
  }
}
